import * as betprofessor from './RaceMeetings.styles.betprofessor';
import * as betroyale from './RaceMeetings.styles.betroyale';
import * as fiestabet from './RaceMeetings.styles.fiestabet';
import * as puntcity from './RaceMeetings.styles.puntcity';
import * as puntgenie from './RaceMeetings.styles.puntgenie';
import * as questbet from './RaceMeetings.styles.questbet';
import * as sterlingparker from './RaceMeetings.styles.sterlingparker';
import * as vikingbet from './RaceMeetings.styles.vikingbet';
import * as volcanobet from './RaceMeetings.styles.volcanobet';
import * as wellbet from './RaceMeetings.styles.wellbet';
import * as juicybet from './RaceMeetings.styles.juicybet';
import * as goldenrush from './RaceMeetings.styles.goldenrush';
import * as forsport from './RaceMeetings.styles.forsport';
import * as junglebet from './RaceMeetings.styles.junglebet';
import * as sugarcastle from './RaceMeetings.styles.sugarcastle';
import * as oldgill from './RaceMeetings.styles.oldgill';
import * as buffalobet from './RaceMeetings.styles.buffalobet';
import * as titanbet from './RaceMeetings.styles.titanbet';
import * as slambet from './RaceMeetings.styles.slambet';
import * as gigabet from './RaceMeetings.styles.gigabet';
import * as betstride from './RaceMeetings.styles.betstride';
import * as templebet from './RaceMeetings.styles.templebet';
import * as goldenbet888 from './RaceMeetings.styles.goldenbet888';
import * as hyperbet from './RaceMeetings.styles.hyperbet';
import * as bet777 from './RaceMeetings.styles.bet777';
import * as chromabet from './RaceMeetings.styles.chromabet';
import * as bet575 from './RaceMeetings.styles.bet575';
import * as epicodds from './RaceMeetings.styles.epicodds';
import * as pyramidbet from './RaceMeetings.styles.pyramidbet';
import * as magnumbet from './RaceMeetings.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betprofessor,
  betroyale,
  fiestabet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  juicybet,
  goldenrush,
  forsport,
  junglebet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
